import TransactionListing from "./transactionListing";

const TransactionManagement = {
  TransactionListing: TransactionListing,
};
export default TransactionManagement;
